module.exports = __webpack_public_path__ + "static/arktitle-95afcba082f6f86febc81570ac66856e.png";